const SuccessView = ({ name, virtualFill }) => {
  const displayName = (name || '').trim();

  return (
    <div className="success-view">
      <h1>¡Qué alegría tenerte con nosotros, {displayName}!</h1>
      <p>
        Has dado un paso importante. Pronto alguien de nuestro equipo te contactará para acompañarte
        en este nuevo camino.
      </p>
      {virtualFill && <p>En máximo 30 minutos el libro estará llegando a tu correo.</p>}
    </div>
  );
};

export default SuccessView;
